export default __webpack_public_path__ + "static/media/bik_add.f88b8aa7.jpg";